import { PayloadAction } from '@reduxjs/toolkit'
import axios, { AxiosResponse } from 'axios'
import { all, call, put, takeEvery } from 'redux-saga/effects'
import { closeModal } from 'shared/store/modal'
import {
  newOwnersDetailError,
  newOwnersDetailRequest,
  newOwnersDetailSuccess,
  newOwnerUpdateStatusError,
  newOwnerUpdateStatusRequest,
  newOwnerUpdateStatusSuccess,
} from '.'
import {
  getNewOwnerDetails,
  updateNewOwnerStatus,
} from '../../api/change-of-ownership.api'
import {
  INewOwnerDetailModel,
  INewOwnerDetailUpdateModel,
} from '../../models/NewOwners'

function* fetchDetails({ payload }: PayloadAction<string>) {
  try {
    const response: AxiosResponse<INewOwnerDetailModel> = yield call(
      getNewOwnerDetails,
      payload
    )
    yield put(newOwnersDetailSuccess(response.data))
  } catch (e) {
    if (!axios.isCancel(e)) {
      console.log(e)
      yield put(newOwnersDetailError(e))
    }
  }
}

function* updateStatus({ payload }: PayloadAction<INewOwnerDetailUpdateModel>) {
  try {
    yield call(updateNewOwnerStatus, payload)
    yield put(newOwnersDetailRequest(payload.approvalId))
    yield all([put(newOwnerUpdateStatusSuccess()), put(closeModal())])
  } catch (e) {
    console.log(e)

    yield put(newOwnerUpdateStatusError(e))
  }
}

function* newOwnersDetailSaga() {
  yield takeEvery(newOwnersDetailRequest.type, fetchDetails)
  yield takeEvery(newOwnerUpdateStatusRequest.type, updateStatus)
}

export default newOwnersDetailSaga
